import * as React from "react";
import { forwardRef } from "react";
const SvgStandardOperatorUrgency = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { x: 1, y: 1, width: 22, height: 22, rx: 3, fill: "currentColor" }), /* @__PURE__ */ React.createElement("rect", { x: 1, y: 1, width: 22, height: 22, rx: 3, stroke: "#1E233E", strokeWidth: 2 }), /* @__PURE__ */ React.createElement("circle", { cx: 12, cy: 12, r: 2.5, fill: "#1E233E" }));
const ForwardRef = forwardRef(SvgStandardOperatorUrgency);
export default ForwardRef;
